export default __webpack_public_path__ + "static/media/login.ab931d77.jpg";